import './index.css'
import { isDeviceTypePhone } from '@disco/state-management/selectors/app'
import {
  getTracksLimits,
  getUsersLimits,
} from '@disco/state-management/selectors/user'
import { ENTERPRISE_ID } from '@disco/utils/featuresAccessLevel'
import type { BillingRootPath } from '@disco/utils/pricing'

import React from 'react'
import { useSelector } from 'hooks/use-redux'
import type { AccountPlan } from 'types/business2020'
import type { User } from 'types/user'
import PricingPlan from './pricing-plan'
type Props = {
  onPlanSelect: (...args: Array<any>) => any
  maxUsersCurrentPlan: number
  maxFilesCurrentPlan: number
  deprecatedPlan: boolean
  plans: AccountPlan[]
  user: User
  rootPath: BillingRootPath
  isPlanChange: boolean
}

const PricingTable = (props: Props): React.ReactNode => {
  const {
    user,
    onPlanSelect,
    maxUsersCurrentPlan,
    maxFilesCurrentPlan,
    deprecatedPlan,
    rootPath,
    isPlanChange,
  } = props
  const isPhone = useSelector(isDeviceTypePhone)
  const usersLimits = useSelector(getUsersLimits)
  const tracksLimits = useSelector(getTracksLimits)
  const activePlan = user?.business?.private_metadata.plan?.id
  const outsideContainer = []
  const plans = props.plans.map(plan => {
    const isChosen = activePlan === plan.handle
    const pricingPlan = (
      <PricingPlan
        key={plan.handle}
        user={user}
        isChosen={isChosen}
        plan={plan}
        onSelect={onPlanSelect}
        maxUsersCurrentPlan={maxUsersCurrentPlan}
        maxFilesCurrentPlan={maxFilesCurrentPlan}
        usersLimitsCurrentPlan={usersLimits.max}
        tracksLimitsCurrentPlan={tracksLimits.max}
        deprecatedPlan={deprecatedPlan}
        rootPath={rootPath}
        isPlanChange={isPlanChange}
      />
    )

    if (plan.handle === ENTERPRISE_ID) {
      if (!isPhone) {
        outsideContainer.push(pricingPlan)
      }

      return null
    }

    return pricingPlan
  })
  return (
    <>
      <div className="PricingTable">{plans}</div>
      {outsideContainer}
    </>
  )
}

export default PricingTable
